import {BaseService} from "./base.service";

class AttendedByServices extends BaseService {
    constructor() {
        super('api/attended-by');
    }
}

export const attendedbyService = new AttendedByServices();
